import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Creators as UsersCreators } from "../store/ducks/users";
import { Creators as StoresCreators } from "../store/ducks/stores";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { Card, Typography, TextField } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import select from "../assets/select.png";
import { CustomButton } from "./CustomButton";
import { styles } from "../theme/styles";
import { decodedData, encodeData } from "../helpers/encode";

const PedidoSelectForm = (props) => {
  const { users, token, storesInfo, storeId, getInfoStores } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [showSelectMessage, setShowSelectMessage] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (selectedStore) {
      navigate(`/pedidoTienda/${selectedStore.idNumber}`);
      encodeData("selectedStore", `${JSON.stringify(selectedStore)}`);
      // localStorage.setItem("selectedStore", JSON.stringify(selectedStore));
    } else {
      setShowSelectMessage(true);
    }
  };

  useEffect(() => {
    const storedSelectedStore = decodedData("selectedStore");
    if (storedSelectedStore) {
      setSelectedStore(JSON.parse(storedSelectedStore));
    }
  }, []);

  useEffect(() => {
    if (selectedStore && token) {
      getInfoStores(token, selectedStore.idNumber);
    }
  }, [token, selectedStore, getInfoStores]);

  const handleRowClick = (user) => {
    setSelectedStore(user);
  };

  const handleSearch = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  return (
    <div style={styles.content}>
      <div style={styles.divCenter}>
        <Card style={styles.containerPedido} variant="outlined">
          <div style={styles.txtPedido}>
            <Typography
              variant="h5"
              color="primary"
              style={styles.reportestitle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-list-details"
                width="36"
                height="36"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#00205b"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M13 5h8" />
                <path d="M13 9h5" />
                <path d="M13 15h8" />
                <path d="M13 19h5" />
                <path d="M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                <path d="M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
              </svg>
              PEDIDO POR TIENDA
            </Typography>
            <span>Selecciona una tienda:</span>
            <TextField
              label="Buscar en la tabla"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <div className="divrep">
            <TableContainer
              sx={{
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ABABAB",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#888",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#f1f1f1",
                },
                "& .MuiTableCell-root": {
                  fontSize: {
                    xs: "8px",
                    sm: "12px",
                    md: "13px",
                  },
                },
              }}
              style={styles.tableStores}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">ID</TableCell>
                    <TableCell align="center">TIENDA</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users &&
                    users.length > 0 &&
                    users.map((user) => {
                      if (
                        user.rol === "STORE" &&
                        user.active === true &&
                        (user.name
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase()) ||
                          user.idNumber.toString().includes(searchTerm))
                      ) {
                        return (
                          <TableRow
                            key={user.idNumber}
                            onClick={() => handleRowClick(user)}
                            style={{ cursor: "pointer" }}>
                            <TableCell align="center">
                              {user.idNumber}
                            </TableCell>
                            <TableCell align="center">{user.name}</TableCell>
                          </TableRow>
                        );
                      }
                      return null;
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={styles.goTienda}>
              {selectedStore && (
                <div>
                  <p>TIENDA : {selectedStore.idNumber}</p>
                  <p>{selectedStore.name}</p>
                </div>
              )}
              {showSelectMessage && (
                <p style={{ color: "red", margin: "5px" }}>
                  Seleccione una tienda antes de continuar
                </p>
              )}
              <CustomButton style={styles.logoP} onClick={handleButtonClick}>
                Ir
              </CustomButton>
            </div>
          </div>
          <img
            alt="Company Logo"
            src={select}
            style={styles.logoRep}
            variant="rounded"
          />
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    users: state.users.users,
    loadingStores: state.users.loading,
    storesInfo: state.stores.storesInfo,
    token: state.users.uid,
    message: state.config.message,
  };
};

const mapDispatchToProps = {
  clearMessage: CreatorsConfig.clearMessage,
  getInfoStores: StoresCreators.getInfoStores,
};

export default connect(mapStateToProps, mapDispatchToProps)(PedidoSelectForm);
